export default function (initialDataInteractor, questionnaireId) {
  let questionnaireInstances = [];

  initialDataInteractor.data.questionnaire_instance_batches.forEach(qib => {
    if (qib.questionnaire_id == questionnaireId) {
      qib.questionnaire_instances.forEach(qi => {
        qi.version = qib.version_number;
        questionnaireInstances.push(qi);
      })
    }
  });

  return questionnaireInstances;
}